export enum FontResources {
  "fonts.com" = "fonts.com",
  "myfonts.net" = "myfonts.net",
}
